module.exports = __webpack_public_path__ + "img/37.2f953fba.png";